var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooltipQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Simulateur-v4.3-",
    transform: "translate(-418.000000, -500.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hero",
    transform: "translate(0.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "INFO",
    transform: "translate(418.000000, 501.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#68B2BB",
    opacity: 0.304234601,
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fillOpacity: 0.5,
    fill: "#68B2BB",
    cx: 9,
    cy: 9,
    r: 6.23076923
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61198094,10.1844792 C8.43226685,8.91014295 9.7311096,8.44452008 9.7311096,7.57862491 C9.7311096,7.14567733 9.46153846,6.78624915 8.93873383,6.78624915 C8.57930565,6.78624915 8.25255276,6.96596324 7.99931926,7.26004084 L7.61538462,6.90878148 C7.95847515,6.51667801 8.40776038,6.23076923 8.98774677,6.23076923 C9.82913547,6.23076923 10.3846154,6.72906739 10.3846154,7.5377808 C10.3846154,8.60789653 9.06943499,9.04084411 9.20013615,10.1844792 L8.61198094,10.1844792 Z M8.44043567,11.3934649 C8.44043567,11.0830497 8.65282505,10.8706603 8.92239619,10.8706603 C9.19196732,10.8706603 9.41252553,11.0830497 9.41252553,11.3934649 C9.41252553,11.6875425 9.19196732,11.8999319 8.92239619,11.8999319 C8.65282505,11.8999319 8.44043567,11.6875425 8.44043567,11.3934649 Z",
    id: "?",
    fill: "#FFFFFF"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipQuestion);
export default __webpack_public_path__ + "static/media/tooltipQuestion.e28118913705d68fce706ff7cc635fba.svg";
export { ForwardRef as ReactComponent };